import React from "react";
import CustomSection from "../components/CustomSection";
import BackButton from "../components/BackButton";


const Terms = () => {
  return (
    <CustomSection type="white">
      <BackButton />
      <div className="m-6 has-text-justified">
        <h1>TÉRMINOS Y CONDICIONES TREFF</h1>
        <br />
        <p></p>
        <br />
        <p>
          Los presentes términos y condiciones (los{" "}
          <b>“Términos y Condiciones”</b>) constituyen el contrato obligatorio
          que rige el acceso, uso y aprovechamiento de los productos y servicios
          ofrecidos a través de los sitios web www.treff.com.mx y y sus
          aplicaciones móviles (en lo sucesivo la <b>“</b>
          <b>Plataforma</b>
          <b>”</b>) de los cuales la sociedad denominada{" "}
          <b>“DX Intermediación Independiente”, S.A.P.I. de C.V</b>. es titular
          (en lo sucesivo el<b> “Titular”</b>), y cuyo domicilio se encuentra
          ubicado en Rinconada de Almería 1504, Las Alamedas Zapopan, Jalisco.
          C.P. 45079.
        </p>
        <br />
        <p>
          Todo usuario que desee acceder y hacer uso de la Plataforma, deberá
          aceptar y sujetarse a los presentes Términos y Condiciones o de lo
          contrario deberá abstenerse de utilizar la Plataforma y de acceder a
          los sitios web www.treff.com.mx y y sus aplicaciones móviles.
        </p>
        <br />
        <p></p>
        <br />
        <p>
          <b>Objeto. </b>
        </p>
        <br />
        <p></p>
        <br />
        <p>
          El presente documento tiene por objeto regular el acceso, uso y
          aprovechamiento de la Plataforma, así como su contenido, productos y
          servicios ofrecidos dentro la misma.
        </p>
        <br />
        <p> </p>
        <br />
        <p>
          El Titular se reserva el derecho de modificar en cualquier momento y
          sin previo aviso, la presentación de los contenidos, la configuración
          de la Plataforma y su funcionalidad. Por lo que el usuario reconoce y
          acepta que el Titular podrá interrumpir, desactivar o cancelar
          cualquiera de los elementos que conforman la Plataforma.
        </p>
        <br />
        <p></p>
        <br />
        <p>
          El acceso a gran parte de los contenidos de la Plataforma estará
          sujeto al registro de los usuarios mediante comprobación de identidad.{" "}
        </p>
        <br />
        <p></p>
        <br />
        <p>
          La Plataforma se encuentra dirigida a personas mayores de edad (18
          años en adelante) y con residencia en la República Mexicana, por lo
          que el Titular no garantiza que la Plataforma cumpla con legislaciones
          extranjeras. Todo usuario en el extranjero que desee hacer uso de la
          Plataforma lo hará bajo su responsabilidad.{" "}
        </p>
        <br />
        <p></p>
        <br />
        <p>
          El Titular podrá administrar o gestionar la Plataforma de manera
          directa o por medio de terceros, lo cual en ningún caso modificará los
          presentes Términos y Condiciones.{" "}
        </p>
        <br />
        <p></p>
        <br />
        <p></p>
        <br />
        <p></p>
        <br />
        <p>
          <b>Definiciones. </b>
        </p>
        <br />
        <p></p>
        <br />
        <p>
          Para efectos del presente documentos, las palabras que debajo se
          enlistan tendrán el significado que se señala, siempre y cuando estas
          sean citadas con mayúscula inicial ya sea en singular o plural.{" "}
        </p>
        <br />
        <p>
          <b>Contratante</b>
          <b>. </b>Aquellos Usuario registrados que contraten servicios a través
          de la Plataforma.{" "}
        </p>
        <br />
        <p></p>
        <br />
        <p>
          <b>Freelancer.</b>
          <b> </b>Aquellos Usuarios registrados que ofrezcan sus servicios a
          través de la Plataforma.
        </p>
        <br />
        <p></p>
        <br />
        <p>
          <b>Plataforma. </b>El espacio web y contenidos ubicados en los sitios
          web www.treff.com.mx y y sus aplicaciones móviles.
        </p>
        <br />
        <p></p>
        <br />
        <p>
          <b>Titular. </b>La sociedad “DX Intermediación Independiente”,
          S.A.P.I. de C.V. propietaria de la Plataforma y de todos los derechos
          de propiedad intelectual inherentes y accesorios.{" "}
        </p>
        <br />
        <p></p>
        <br />
        <p>
          <b>Usuario. </b>Todo Visitante que acceda a la Plataforma y obtenga su
          registro.
        </p>
        <br />
        <p></p>
        <br />
        <p>
          <b>Visitante.</b> Cualquier persona que ingrese a la Plataforma por
          cualquier medio.{" "}
        </p>
        <br />
        <p></p>
        <br />
        <p>
          <b>De los Servicios. </b>
        </p>
        <br />
        <p></p>
        <br />
        <p>
          El Titular desarrolla tecnologías y pone a disposición de usuarios de
          internet, una Plataforma que permiten que personas contraten u
          ofrezcan servicios técnicos o profesionales y hagan crecer su negocio.{" "}
        </p>
        <br />
        <p></p>
        <br />
        <p>
          El Titular no es responsable de los servicios ofrecidos o contratados
          a través de la Plataforma, no garantiza la calidad, veracidad,
          integridad, legitimidad o debido cumplimiento de los mismos, por lo
          que cada Usuario deberá asumir responsabilidad de los servicios
          ofrecidos o contratados por medio de la Plataforma TREFF.
        </p>
        <br />
        <p></p>
        <br />
        <p>
          La Plataforma cuenta con videos de instrucciones de uso del sitio,
          instrucciones escritas la sección de ayuda, así como globos de ayuda
          que al posicionar ahí el cursor explica brevemente las instrucciones.
        </p>
        <br />
        <p></p>
        <br />
        <p></p>
        <br />
        <p>
          No podrá haber contacto directo ni intercambio de datos personales
          entre Usuarios fuera de la plataforma con la finalidad de contratar
          servicios. Esto, en el entendido que el Titular pondrá a disposición
          de los Usuarios los medios de comunicación adecuados dentro de la
          plataforma para el intercambio de información y negociación de los
          servicios, por lo que está estrictamente prohibido el establecimiento
          de comunicaciones entre Usuarios por medios de contacto externos a los
          brindados por la Plataforma y en caso de incumplir esta regla, las
          cuentas de los Usuarios serán eliminada.{" "}
        </p>
        <br />
        <p></p>
        <br />
        <p>
          Los Usuarios podrán hacer uso de la Plataforma como Freelancers, como
          Contratantes o ambas.{" "}
        </p>
        <br />
        <p></p>
        <br />
        <p>
          Dentro de la Plataforma podrá haber servicios de pago por parte de los
          Usuarios (Freelancers y Contratantes), dichos servicios se regirán por
          los presentes Términos y Condiciones y en particular por los apartados{" "}
          <b>IV y</b>
          <b> </b>
          <b>V</b>.{" "}
        </p>
        <br />
        <p></p>
        <br />
        <p>
          <b>De los Usuarios.</b>
        </p>
        <br />
        <p></p>
        <br />
        <p>
          <b>Generalidades. </b>
        </p>
        <br />
        <p>
          El acceso y utilización de la Plataforma asi como de los recursos que
          contiene la misma, están sujetos al registro de los Usuarios, por
          medio del llenado de la solicitud de registro, la aceptación del Aviso
          de Privacidad y de los presentes Términos y Condiciones, mismos que se
          entienden aceptados a partir de la creación de una cuenta de Usuario
          en la Plataforma.
        </p>
        <br />
        <p></p>
        <br />
        <p>
          Todo Usuario registrado deberá proporcionar información precisa sobre
          si mismos, utilizar el mismo nombre que usan en la vida cotidiana,{" "}
          <b>crear una sola cuenta</b> y no compartir su contraseña o conceder
          el acceso a ningún tercero.
        </p>
        <br />
        <p> </p>
        <br />
        <p>
          <b>No podrán ser Usuarios: </b>
        </p>
        <br />
        <p></p>
        <br />
        <p>Menores de 18 años; </p>
        <br />
        <p>Personas incapaces; </p>
        <br />
        <p>
          Personas cuya cuenta haya sido cancelada en términos de los presentes
          Términos y Condiciones; y
        </p>
        <br />
        <p>
          Personas que, en términos de la legislación vigente o de una sentencia
          judicial, se encuentren inhabilitados para contratar, obligarse o
          adquirir productos o servicios como los que se encuentran en la
          Plataforma.
        </p>
        <br />
        <p></p>
        <br />
        <p>
          El Titular se reserva el derecho de admitir y/o cancelar el acceso a
          aquellos usuarios que no cumplan con los requisitos de verificación de
          identidad, aquellos que no acepten los presentes Términos y
          Condiciones en su versión vigente, o bien, aquellos usuarios que,
          derivado de algún reclamo, queja o procedimiento, hayan incumplido o
          violado las disposiciones contenidas en los presentes Términos y
          Condiciones y su cuenta haya sido cancelada en términos del apartado
          IX.{" "}
        </p>
        <br />
        <p></p>
        <br />
        <p>
          <b>De las Insignias. </b>
        </p>
        <br />
        <p>
          La Plataforma cuenta con un sistema de recompensas por insignias para
          Freelancers y Contratantes de acuerdo a los niveles y recompensas
          vigentes.
        </p>
        <br />
        <p>
          <b>Insignia de verificación. </b>
        </p>
        <br />
        <p>
          Aquellos Usuarios que verifiquen su identidad por los medios que
          señale la plataforma, obtendrán una insignia correspondiente que
          indique que sus perfiles han sido verificados.
        </p>
        <br />
        <p>
          <b>Insignia de promociones. </b>
        </p>
        <br />
        <p>
          La Plataforma generará promociones o recompensas para aquellos
          Usuarios que cumplan con ciertas características o requisitos, estos
          Usuarios estarán identificados con insignias especiales, mismas que
          podrán variar conforme a las promociones y recompensas vigentes.{" "}
        </p>
        <br />
        <p></p>
        <br />
        <p>
          <b>De los Freelancers. </b>
        </p>
        <br />
        <p></p>
        <br />
        <p>
          Los Freelancers o prestadores de servicios son aquellos Usuarios con
          un registro en el Plataforma y que oferten sus servicios técnicos,
          profesionales o diversos dentro de la misma, pudiendo ofertar
          servicios de manera ilimitada dentro de su cuenta.
        </p>
        <br />
        <p>
          Todos los Freelancers pasaran por un proceso de validación de
          información personal, mismo que se realiza al amparo del aviso de
          Privacidad contenido en:{" "}
          <a
            className="has-text-link"
            href="https://treff-site.azurewebsites.net/terms"
          >
            https://treff-site.azurewebsites.net/terms
          </a>
          .{" "}
        </p>
        <br />
        <p></p>
        <br />
        <p>
          <b>Servicios y comisiones. </b>
        </p>
        <br />
        <p></p>
        <br />
        <p>
          Los Freelancers estarán habilitados para ofrecer 3 tres tipos de
          servicios y el Titular cobrará las comisiones siguientes.{" "}
        </p>
        <br />
        <p></p>
        <br />
        <p>
          Los precios de los servicios serán establecidos libremente por el
          Freelancer y las comisiones se causarán sobre el precio final.{" "}
        </p>
        <br />
        <p>
          El cobro de las comisiones se realizará mediate retenciones que
          llevará a cabo el Titular previo a transferir los fondos a la cuenta
          autorizada por el Freelancer para el pago de sus servicios.
        </p>
        <br />
        <p></p>
        <br />
        <p>
          <b>Extras.</b>
        </p>
        <br />
        <p></p>
        <br />
        <p>
          Los Freelancers tendrán a su disposición servicios adicionales con
          costo extra conforme a lo siguiente:
        </p>
        <br />
        <p></p>
        <br />
        <p></p>
        <br />
        <p></p>
        <br />
        <p>
          <b>Incentivos Fijos. </b>
        </p>
        <br />
        <p>
          La Plataforma contará con los siguientes incentivos para Freelancers.{" "}
        </p>
        <br />
        <p>
          Top 5 ventas (a los 5 Freelancers que tengan el mayor número de
          operaciones cerradas al mes).
        </p>
        <br />
        <p>
          Top 5 ratings (a los 5 Freelancers con mayor número de calificaciones
          altas obtenidas).
        </p>
        <br />
        <p>
          Bonos de inscripción (promoción temporal y sujeta a promoción
          vigente).{" "}
        </p>
        <br />
        <p>
          No obstante, el Titular se reserva el derecho de mostrar a su
          discreción estos incentivos y pondrá a disposición de los Usuarios,
          todas las promociones o incentivos vigentes dentro de la Plataforma.{" "}
        </p>
        <br />
        <p></p>
        <br />
        <p>
          <b>Prohibiciones</b>
          <b> y Sanciones</b>
          <b>. </b>
        </p>
        <br />
        <p></p>
        <br />
        <p>
          Ningún Freelancer podrá tener más de una cuenta. La creación de
          diversas cuentas dentro de la Plataforma por una misma persona será
          motivo de cancelación de las cuentas.
        </p>
        <br />
        <p> </p>
        <br />
        <p>
          Aquel Freelancer que incumpla en las fechas de entrega pactadas con
          los Contratantes (teniendo un plazo de 12 doce horas adicionales de
          tolerancia) será amonestado.{" "}
        </p>
        <br />
        <p></p>
        <br />
        <p>
          Los Freelancer solamente podrán ofrecer servicios lícitos y todo
          servicio ofrecido y prestado, será bajo su total responsabilidad y de
          la de quien lo contrata.{" "}
        </p>
        <br />
        <p></p>
        <br />
        <p>
          De igual forma, se amonestará al Freelancer que no entregue el trabajo
          a que se obligó por medio de la Plataforma, para lo cual, el
          Freelancer estará obligado a limitar y definir el alcance de sus
          servicios o trabajos con la mayor claridad posible, siendo bajo la
          responsabilidad del Contratante aceptar los términos ofrecidos por el
          Freelancer.{" "}
        </p>
        <br />
        <p></p>
        <br />
        <p>
          La acumulación de 3 tres amonestaciones en un transcurso de 6 seis
          meses, dará a lugar a la cancelación de la cuenta del Freelancer.{" "}
        </p>
        <br />
        <p></p>
        <br />
        <p></p>
        <br />
        <p>
          No podrá haber contacto directo y por fuera de la Plataforma entre
          Freelancer y Contratante, ni intercambio de datos personales sin
          previa aprobación del Titular de la Plataforma. El incumplimiento a lo
          anterior será motivo de cancelación de las cuentas del Freelancer y
          del Contratante.{" "}
        </p>
        <br />
        <p></p>
        <br />
        <p></p>
        <br />
        <p>
          De dará de baja la cuenta de aquel Freelancer que reciba más de 2 dos
          quejas (ver apartado VI. Reclamos y Quejas) en un periodo de 6 seis
          meses, se dará de baja su cuenta.{" "}
        </p>
        <br />
        <p></p>
        <br />
        <p>
          <b>De los </b>
          <b>Contratante</b>
          <b>s</b>
          <b> </b>
        </p>
        <br />
        <p></p>
        <br />
        <p>
          Los Usuarios que se registren en la Plataforma con la finalidad de
          contratar servicios técnicos o profesionales de los Freelancers, serán
          identificados como Contratantes, quienes quedarán sujetos a lo
          dispuesto en el presente apartado y el resto de los Términos y
          Condiciones.{" "}
        </p>
        <br />
        <p></p>
        <br />
        <p>
          Los Contratantes estarán obligados a realizar el pago del servicio
          contratado de manera anticipada a la entrega del trabajo o producto
          del servicio para lo cual contarán con un perfil y panel de control
          para el registro y seguimiento de sus operaciones.
        </p>
        <br />
        <p></p>
        <br />
        <p>
          Por su parte, el Titular se encargará de retener el pago al Freelancer
          hasta que se verifique la entrega en tiempo y forma del trabajo
          acordado.{" "}
        </p>
        <br />
        <p></p>
        <br />
        <p>
          Aquellos Visitantes que no deseen registrarse, pero decidan contratar
          los servicios de un Freelancer, serán considerados Contratantes y
          podrán hacerlo mediante la aceptación de los presentes Términos y
          Condiciones y debiendo proporcionar su correo electrónico, número
          telefónico y aceptar las siguientes condiciones específicas:{" "}
        </p>
        <br />
        <p></p>
        <br />
        <p>
          Solo tendrán derecho a 1 un reclamo (ver apartado de <b>“</b>
          <b>Reclamos</b>
          <b> y Quejas</b>
          <b>”</b>).
        </p>
        <br />
        <p>No tendrán acceso a compras recurrentes.</p>
        <br />
        <p>No tendrán historial de compras.</p>
        <br />
        <p>No tendrán beneficios por descuentos y/o insignias.</p>
        <br />
        <p>
          Al momento del pago, deberán aceptar los presentes Términos y
          Condiciones.
        </p>
        <br />
        <p></p>
        <br />
        <p>
          <b>Pagos</b>
          <b> y </b>
          <b>reembolsos</b>
          <b>.</b>
        </p>
        <br />
        <p></p>
        <br />
        <p>
          <b>Generalidades.</b>
        </p>
        <br />
        <p></p>
        <br />
        <p>
          Los Contratantes deberán pagar de manera anticipada los servicios del
          Freelancer, ya sea mediante pago con tarjeta de débito, crédito,
          paypal o mediante otros medios de pago ofrecidos por la Plataforma
          (con 24 horas de tolerancia).
        </p>
        <br />
        <p></p>
        <br />
        <p>
          Un servicio no podrá ser confirmado hasta en tanto no se realice y
          acredite el pago correspondiente en la Plataforma.{" "}
        </p>
        <br />
        <p></p>
        <br />
        <p>
          Los Contratantes tendrán la opción de guardar sus tarjetas para
          futuras compras rápidas, agregar nuevas tarjetas o bien realizar
          operaciones sin que su tarjeta quede guardada.
        </p>
        <br />
        <p></p>
        <br />
        <p>
          El Titular se reserva el derecho de contratar a un tercero como
          proveedor de servicios para procesamiento de pagos y almacenamiento de
          información de tarjetas de crédito o débito, por lo que el Usuario
          deberá aceptar los términos y condiciones de dicho proveedor al
          momento de acceder a los servicios de pago.
        </p>
        <br />
        <p></p>
        <br />
        <p>
          <b>Pago a Freelancers.</b>
        </p>
        <br />
        <p></p>
        <br />
        <p>
          Los Freelancer tendrán la obligación de subir a la Plataforma y
          mantener actualizada la información bancaria de las cuentas en las
          cuales deban de hacerse los pagos de sus servicios.
        </p>
        <br />
        <p></p>
        <br />
        <p>
          El Titular no se hace responsable por errores, cuentas canceladas o
          cualquier otra razón por la que no puedan transferirse fondos a las
          cuentas indicadas por el Freelancer para la recepción de pagos.{" "}
        </p>
        <br />
        <p></p>
        <br />
        <p>
          No enviaremos el importe pagado por el Contratante a la cuenta del
          Freelancer hasta en tanto no se verifique que:
        </p>
        <br />
        <p></p>
        <br />
        <p>
          El trabajo fue entregado o el servicio prestado efectivamente en la
          fecha y hora pactada, verificado mediante correo de confirmación de
          envío; el Freelancer tendrá 12 doce horas adicionales de tolerancia
          para entregar su trabajo a partir del vencimiento de su fecha y hora
          pactada
        </p>
        <br />
        <p></p>
        <br />
        <p>
          El Freelancer no deberá tener ningún reclamo abierto relacionada con
          el mismo trabajo.
        </p>
        <br />
        <p></p>
        <br />
        <p>
          Los pagos se realizarán solamente a las cuentas que hayan sido
          autorizadas por el Freelancer a través de la Plataforma o, en su
          defecto, mediante Paypal.{" "}
        </p>
        <br />
        <p></p>
        <br />
        <p></p>
        <br />
        <p>
          <b>Cancelaciones y </b>
          <b>Reembolsos.</b>
        </p>
        <br />
        <p></p>
        <br />
        <p>
          Los Contratantes tendrán derecho a que les sea reembolsado el importe
          de su compra en los siguientes casos.
        </p>
        <br />
        <p></p>
        <br />
        <p>Reclamos resueltos en su favor (ver apartado Reclamos y Quejas). </p>
        <br />
        <p>
          Cancelación por encontrar un servicio que se ajuste mejor a sus
          necesidades;
        </p>
        <br />
        <p>Cancelación por encontrar un mejor precio;</p>
        <br />
        <p>Cancelación por que no necesita o no requiere servicio;</p>
        <br />
        <p>Cancelación por aplazamiento; </p>
        <br />
        <p>
          Los reembolsos por las cancelaciones señaladas en los incisos 2. 3. 4.
          y 5. anteriores están sujetas al pago de una comisión del 10% sobre el
          servicio contratado y a la confirmación por correo del Freelancer (30
          minutos de tolerancia).
        </p>
        <br />
        <p>
          Asimismo, los Freelancers podrán cancelar un servicio por los
          siguientes motivos:{" "}
        </p>
        <br />
        <p>Reclamos resueltas en su favor. (ver apartado Reclamos y Quejas).</p>
        <br />
        <p>Imposibilidad para entregar un servicio. </p>
        <br />
        <p>
          Servicios aceptados por error. (Debe ser dictaminado en reclamo).{" "}
        </p>
        <br />
        <p></p>
        <br />
        <p>
          <b>Reclamos</b>
          <b> y Quejas.</b>
        </p>
        <br />
        <p>
          <b> </b>
        </p>
        <br />
        <p>
          La Plataforma cuenta con un sistema de Reclamos y Quejas para los
          Usuarios, quienes deberán de seguir los pasos indicados en el apartado
          de reclamos correspondiente para poder iniciar un reclamo o acceder a
          un reclamo abierto.{" "}
        </p>
        <br />
        <p></p>
        <br />
        <p>
          <b>L</b>
          <b>os Reclamos</b>
          <b>.</b>
        </p>
        <br />
        <p></p>
        <br />
        <p>
          Los reclamos serán atendidas y resueltas de manera definitiva por un
          administrador de la Plataforma siguiendo los pasos, reglas y plazos de
          reclamos señaladas en la Plataforma misma.{" "}
        </p>
        <br />
        <p></p>
        <br />
        <p>Serán motivo de Reclamo los siguientes: </p>
        <br />
        <p></p>
        <br />
        <p>La cancelación de un servicio por parte de un Freelancer; </p>
        <br />
        <p>
          La solicitud de reembolso de un servicio solicitada por un
          Contratante;
        </p>
        <br />
        <p>Inconformidad por producto o trabajo entregado;</p>
        <br />
        <p>
          Inconformidad respecto de instrucciones dadas por los Contratantes;
        </p>
        <br />
        <p>
          Incumplimientos de obligaciones a cargo de cualquiera de las partes;
        </p>
        <br />
        <p>Solicitar datos personales de algún Usuario;</p>
        <br />
        <p>
          El incumplimiento a cualquier parte de estos Términos y Condiciones; y
        </p>
        <br />
        <p>
          Cualquier desacuerdo entre Usuarios de la Plataforma que requiera
          resolución por parte de un administrador.{" "}
        </p>
        <br />
        <p></p>
        <br />
        <p>
          <b>Las Quejas. </b>
        </p>
        <br />
        <p></p>
        <br />
        <p>
          La Plataforma cuenta con un apartado para la presentación de quejas
          entre usuarios. Todo Usuario deberá seguir los procedimientos
          indicados en la Plataforma para la presentación de quejas.{" "}
        </p>
        <br />
        <p></p>
        <br />
        <p>
          Todas las quejas serán evaluadas por un administrador de la
          Plataforma, y aquellos Usuarios que reciban quejas consideradas como
          faltas graves a juicio del administrador, serán dadas de baja de
          inmediato.{" "}
        </p>
        <br />
        <p></p>
        <br />
        <p>
          <b>Aviso de Privacidad y Protección de Datos. </b>
        </p>
        <br />
        <p>
          En cumplimiento de la Ley Federal De Protección De Datos Personales En
          Posesión De Los Particulares, el Titular pone a disposición de los
          Usuarios su aviso de privacidad en la siguiente dirección electrónica
          _______________________________________________
        </p>
        <br />
        <p>
          Dicho aviso de privacidad dispone y regula el tratamiento que se dará
          a los datos personales compartidos por los Usuarios dentro de la
          Plataforma.
        </p>
        <br />
        <p></p>
        <br />
        <p>
          <b>Derechos de Propiedad </b>
          <b>Intelectual.</b>
          <b> </b>
        </p>
        <br />
        <p></p>
        <br />
        <p>
          La sociedad <b>“DX Intermediación Independiente”, S.A.P.I. de C.V</b>
          <b>. </b>es único dueño y titular de los derechos de propiedad
          intelectual contenidos en la Plataforma, así como de todos aquellos
          que se integren a la misma con el tiempo.{" "}
        </p>
        <br />
        <p></p>
        <br />
        <p>
          Todo Usuario reconoce que no podrá reproducir, comercializar,
          replicar, explotar o de cualquier forma aprovecharse comercialmente de
          aquellos derechos de propiedad intelectual contenidos y alojados
          dentro de la Plataforma y aplicaciones móviles.{" "}
        </p>
        <br />
        <p></p>
        <br />
        <p>
          Los Usuarios reconocen como derechos de propiedad intelectual, todas
          las marcas, patentes, modelos de utilidad, nombres comerciales, avisos
          comerciales, diseños industriales, imágenes, archivos, logotipos,
          combinaciones de colores, estructuras, secretos industriales, derechos
          de autor, código fuente y programas de computo propiedad del Titular,
          sus socios, afiliados y cualquier otra parte relacionada.{" "}
        </p>
        <br />
        <p></p>
        <br />
        <p>
          <b>Cancelación de la cuenta de Usuarios. </b>
        </p>
        <br />
        <p></p>
        <br />
        <p>
          Sin perjuicio de otras acciones, el Titular estará facultado para
          advertir, suspender o cancelar de manera temporal o definitiva la
          cuenta de cualquier Usuario o publicación, e inclusive suspender la
          prestación de sus servicios cuando se viole alguna disposición legal,
          cualquier apartado de los presentes Términos y Condiciones y de manera
          especial, cuando ocurra cualquiera de los siguientes casos:{" "}
        </p>
        <br />
        <p></p>
        <br />
        <p>Lenguaje de odio en cualquiera de los medios de contacto;</p>
        <br />
        <p></p>
        <br />
        <p>No pudiera verificarse la identidad de un Usuario;</p>
        <br />
        <p></p>
        <br />
        <p>
          Cuentas múltiples por correo, teléfono o cuenta bancaria; también IP.
        </p>
        <br />
        <p></p>
        <br />
        <p>
          Cuando un Usuario se auto contrato o auto califique de manera directa
          o indirecta con fines de mejorar rating o reputación;
        </p>
        <br />
        <p></p>
        <br />
        <p>
          Intercambio de datos personales o establecimiento de comunicaciones
          entre usuarios por medios externos a la Plataforma, siempre que se
          trate de contratar servicios de un Freelancer;
        </p>
        <br />
        <p></p>
        <br />
        <p>Intento de fraude con pagos por alguna plataforma (PayPal);</p>
        <br />
        <p></p>
        <br />
        <p>El ofrecimiento de servicios y/o productos ilegales;</p>
        <br />
        <p></p>
        <br />
        <p>Quejas consideradas graves;</p>
        <br />
        <p></p>
        <br />
        <p>
          El intento o acción de subir virus o códigos maliciosos o cualquier
          otra actividad similar que pretenda impedir, sobrecargar o afectar el
          correcto funcionamiento de la Plataforma y de los datos que contiene;
        </p>
        <br />
        <p></p>
        <br />
        <p>La copia de descripciones y/o fotos de otros Freelancers</p>
        <br />
        <p></p>
        <br />
        <p>Violaciones a los presentes Términos y Condiciones; </p>
        <br />
        <p></p>
        <br />
        <p>
          Plagio o violación de derechos de propiedad intelectual e industrial.
        </p>
        <br />
        <p></p>
        <br />
        <p></p>
        <br />
        <p>
          <b>Política de cookies</b>
          <b>.</b>
        </p>
        <br />
        <p>
          <b> </b>
        </p>
        <br />
        <p>
          Una cookie es un pequeño fragmento de texto que los sitios web que
          visitas envían a tu navegador. Las cookies permiten que los sitios
          recuerden información sobre tu visita, lo que puede hacer que sea más
          fácil volver a visitar los sitios y que estos te resulten más útiles.
        </p>
        <br />
        <p></p>
        <br />
        <p>
          La Plataforma utiliza cookies para distinguirte de los otros Usuarios.
          Esto nos ayuda a proporcionarte una buena experiencia cuando navegues
          la Plataforma y también nos permite mejorarla. Al acceder a la
          Plataforma, aceptas nuestro uso de cookies.
        </p>
        <br />
        <p></p>
        <br />
        <p>Utilizamos las siguientes cookies:</p>
        <br />
        <p></p>
        <br />
        <p>
          <b>Cookies estrictamente necesarias</b>. Estas son las cookies
          requeridas para el funcionamiento de la Plataforma. Incluyen, por
          ejemplo, cookies que te permiten iniciar sesión en áreas seguras de
          nuestro Sitio o utilizar un carrito de compras.
        </p>
        <br />
        <p></p>
        <br />
        <p>
          <b>Cookies analíticas/de rendimiento.</b> Nos permiten reconocer y
          contar el número de visitantes y ver cómo se desplazan los visitantes
          la Plataforma. Esto nos ayuda a mejorar el funcionamiento la
          Plataforma, por ejemplo, asegurándonos de que los Usuarios encuentran
          lo que están buscando fácilmente.
        </p>
        <br />
        <p></p>
        <br />
        <p>
          Puedes bloquear las cookies al activar los ajustes en tu navegador que
          te permiten rechazar los ajustes de todas o de algunas cookies. Sin
          embargo, si utilizas los ajustes de tu navegador para bloquear todas
          las cookies (incluyendo las cookies esenciales), no podrás acceder a
          nuestro Sitio o a parte del mismo.
        </p>
        <br />
        <p></p>
        <br />
        <p>
          <b>Limites a la responsabilidad. </b>
        </p>
        <br />
        <p></p>
        <br />
        <p>
          El Titular ofrece un servicio vía internet para efecto de poner en
          contacto a profesionistas y prestadores de servicios con contratantes
          potenciales, sin embargo, el Titular no tendrá responsabilidad ni
          garantiza:{" "}
        </p>
        <br />
        <p></p>
        <br />
        <p>
          La continuidad de la Plataforma o su contenido, por lo que no
          garantiza que siempre esté disponible o no se interrumpa la conexión;{" "}
        </p>
        <br />
        <p></p>
        <br />
        <p>
          El cálculo y entero de impuestos que deban hacer los prestadores de
          servicios que reciban una remuneración por medio de la Plataforma;
        </p>
        <br />
        <p></p>
        <br />
        <p>
          Que la Plataforma se encuentre libre de virus o sea completamente
          segura;{" "}
        </p>
        <br />
        <p></p>
        <br />
        <p>
          Sucesos fuera del control del Titular, así como de aquellos que
          deriven del caso fortuito o fuerza mayor;{" "}
        </p>
        <br />
        <p></p>
        <br />
        <p>
          De actos, publicaciones, mensajes privados o cualquier comunicación
          emitida por un Usuario y que afecte derechos de terceros;{" "}
        </p>
        <br />
        <p></p>
        <br />
        <p>De actos fraudulentos entre Usuarios; </p>
        <br />
        <p></p>
        <br />
        <p>
          Del cumplimiento de las obligaciones que asumen los Usuarios en las
          relaciones entre ellos;
        </p>
        <br />
        <p>
          El Titular no tiene control ni influencia sobre lo que los Usuarios
          publican o dicen en conversaciones privadas dentro de la Plataforma,
          por lo que la Plataforma ni su Titular son responsables de estos
          comportamientos o acciones, ya sean dentro o fuera de la Plataforma,
          ni del contenido de publiquen.
        </p>
        <br />
        <p>
          La responsabilidad del Titular se limita al máximo alcance legal
          aplicable, y en ninguna circunstancia, será responsable por la pérdida
          de ganancias, ingresos o información, ni por daños derivados de estos.{" "}
        </p>
        <br />
        <p></p>
        <br />
        <p></p>
        <br />
        <p>
          <b>Modificación a los Términos y Condiciones. </b>
        </p>
        <br />
        <p></p>
        <br />
        <p>
          El Titular se reserva el derecho de modificar en cualquier momento los
          presentes Términos y Condiciones, lo cual será notificado a los
          Usuarios por medio del correo electrónico que estos hubiesen
          registrado.{" "}
        </p>
        <br />
        <p></p>
        <br />
        <p>
          Una vez implementadas las actualizaciones a los presentes Términos y
          Condiciones, todos los Usuarios quedarán sujetos a ellas si continúan
          accediendo a la Plataforma.
        </p>
        <br />
        <p></p>
        <br />
        <p>
          <b>Enlaces de terceros y recursos en la Plataforma. </b>
        </p>
        <br />
        <p></p>
        <br />
        <p>
          Cuando la Plataforma contenga enlaces a otros sitios y recursos
          proporcionados por terceros, dichos enlaces se proporcionarán
          únicamente para tu información. No ejercemos ningún control sobre el
          contenido de dichos sitios o recursos.
        </p>
        <br />
        <p></p>
        <br />
        <p>
          No asumimos responsabilidad alguna sobre el contenido de los enlaces
          de las páginas web en la Plataforma. Dichos enlaces no deberán ser
          interpretados como un respaldo por nuestra parte a dichos enlaces de
          las páginas web. No seremos responsables de cualquier pérdida o daño
          que pueda surgir del uso que hagas de los mismos.
        </p>
        <br />
        <p></p>
        <br />
        <p>
          <b>Jurisdicción y Competencia. </b>
        </p>
        <br />
        <p>
          Para la interpretación, resolución, ejecución y cumplimiento del
          presente acuerdo, las partes se someten expresamente a las leyes y
          tribunales competentes de la Ciudad de México, renunciando a cualquier
          otro fuero que por razón de domicilio u otra causa, tuvieren o
          llegaren a adquirir.
        </p>
        <br />
        <p>
          Si cualquier parte de estos Términos y Condiciones no fuese aplicable,
          la parte restante seguirá siendo de plena aplicación y vigencia. La no
          aplicación de alguna de estas disposiciones por nuestra parte no se
          considerará una renuncia. Cualquier modificación de estos Términos y
          Condiciones o renuncia respecto a ellos deberá hacerse por escrito y
          contar con la firma del Titular.{" "}
        </p>
        <br />
        <p>
          <b>Contacto</b>
          <b>.</b>
        </p>
        <br />
        <p></p>
        <br />
        <p>
          Para todo lo relacionado con los presentes Términos y Condiciones o el
          uso de la Plataforma, el Titular pone a su disposición los siguientes
          datos de contacto.{" "}
        </p>
        <br />
        <p></p>
        <br />
        <p>
          <b>Correo electrónico:</b> hola.treff@gmail.com
        </p>
        <br />
        <p>
          <b>Domicilio:</b> Rinconada de Almería 1504, Las Alamedas Zapopan,
          Jalisco. C.P. 45079.
        </p>
        <br />
        <p></p>
        <br />
        <p>
          <b>Publicaciones, mensajes y comunidad.</b>
        </p>
        <br />
        <p></p>
        <br />
        <p>
          Cada Usuario es responsable por el contenido de sus publicaciones y
          mensajes privados entre usuarios.{" "}
        </p>
        <br />
        <p></p>
        <br />
        <p>
          Queda prohibida la publicación, divulgación o comunicación dentro de
          la plataforma de:{" "}
        </p>
        <br />
        <p></p>
        <br />
        <p>Todo tipo de violencia o incitación a la misma;</p>
        <br />
        <p></p>
        <br />
        <p>
          Publicaciones que incumplan los presentes Términos y Condiciones;{" "}
        </p>
        <br />
        <p></p>
        <br />
        <p>Actos de acoso (bullying);</p>
        <br />
        <p></p>
        <br />
        <p></p>
        <br />
        <p>
          Publicaciones que infrinjan o vulneren derechos de terceros, incluidos
          derechos de propiedad intelectual;
        </p>
        <br />
        <p></p>
        <br />
        <p>Infracciones a la privacidad;</p>
        <br />
        <p></p>
        <br />
        <p>Lenguaje que incite al odio;</p>
        <br />
        <p></p>
        <br />
        <p>Contenido gráfico o violento;</p>
        <br />
        <p></p>
        <br />
        <p>Desnudos y actividad sexual de adultos; </p>
        <br />
        <p></p>
        <br />
        <p>Servicios sexuales; </p>
        <br />
        <p></p>
        <br />
        <p>
          Spam. Entendido como la publicación, interacción o comunicación de
          contenidos de forma manual o automática con una frecuencia
          innecesariamente elevada); y
        </p>
        <br />
        <p></p>
        <br />
        <p>Publicación de información falsa.</p>
        <br />
        <p>
          En términos del apartado IX. Fracción j. Todo Usuario que incumpla o
          viole las disposiciones relativas a publicaciones, mensajes y
          comunidad será dado de baja de la Plataforma y su cuenta quedará
          cancelada de manera permanente.
        </p>
        <br />
        <p></p>
        <br />
        <p>
          <b>Supletoriedad. </b>
        </p>
        <br />
        <p>
          Para todo aquello que no se encuentre regulado en los presentes
          Términos y Condiciones, regirá lo dispuesto por el Código Civil
          Federal Vigente, las disposiciones aplicables del Código de Comercio
          en vigor, así como de la Ley Federal de Protección al Consumidor y
          legislaciones federales aplicables.{" "}
        </p>
        <br />
        <p></p>
        <br />
        <p></p>
        <br />
      </div>
    </CustomSection>
  );
};

export default Terms;
